/**
 * App Store Module
 *
 * This module handles global application state including vendor styling information.
 */

const state = {
	vendorData: null,
};

const getters = {
	vendorData: (state) => state.vendorData,
};

const actions = {
	setVendorData({ commit }, vendorData) {
		commit("setVendorData", vendorData);
	},
};

const mutations = {
	setVendorData(state, vendorData) {
		state.vendorData = vendorData;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
